import React, { useState, useEffect } from 'react';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${
      scrolled 
        ? 'bg-white/80 backdrop-blur-md shadow-lg py-4' 
        : 'bg-transparent py-6'
    }`}>
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-4">
            <img 
              src={scrolled ? "/images/logo.png" : "/images/logo-blanco.png"} 
              alt="ADVANCE Consortium" 
              className="h-20 w-auto transition-opacity duration-300"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#inicio" className={`hover:text-red-600 transition-colors ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}>Inicio</a>
            <a href="#rutas" className={`hover:text-red-600 transition-colors ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}>Rutas</a>
            <a href="#nosotros" className={`hover:text-red-600 transition-colors ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}>Nosotros</a>
            <a href="#cursos" className={`hover:text-red-600 transition-colors ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}>Cursos</a>
            <button className="bg-gradient-to-r from-red-600 to-red-700 text-white px-6 py-2 rounded-full hover:shadow-lg transform hover:scale-105 transition-all" style={{
              background: 'linear-gradient(to right, #d51231, #a00e27)'
            }}>
              <a href="https://moodle.cadvance.com.co/"
              target="_blank"
              rel="noopener noreferrer">
              Acceso Plataforma</a>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden"
          >
            <svg className={`w-6 h-6 ${scrolled ? 'text-gray-800' : 'text-white'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={mobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 bg-white rounded-xl shadow-xl p-4 animate-fadeInDown">
            <a href="#inicio" className="block py-2 text-gray-700 hover:text-red-600">Inicio</a>
            <a href="#rutas" className="block py-2 text-gray-700 hover:text-red-600">Rutas</a>
            <a href="#nosotros" className="block py-2 text-gray-700 hover:text-red-600">Nosotros</a>
            <a href="#cursos" className="block py-2 text-gray-700 hover:text-red-600">Cursos</a>
            <button className="w-full mt-4 text-white px-6 py-2 rounded-full" style={{
              background: 'linear-gradient(to right, #d51231, #a00e27)'
            }}>
            Acceso Plataforma
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
